(function () {
  'use strict';

  function init() {
    const dataEl = document.querySelector('[data-variant-arrival-dates]');
    const banner = document.querySelector('[data-arrival-date-banner]');
    const bannerText = document.querySelector('[data-arrival-date-text]');
    const hiddenInput = document.querySelector('input[name="id"].product-variant-id');

    if (!dataEl || !banner || !hiddenInput) return;

    let variantData = {};
    try {
      variantData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Arrival dates JSON parse failed', e);
      return;
    }

    const strings = window.variantStrings || {};
    const preorderLabel = strings.preOrder || 'Preorder';
    const addToCartLabel = strings.addToCart || 'Add to cart';
    const soldOutLabel = strings.soldOut || 'Sold out';

    function update() {
      const variantId = hiddenInput.value;
      const info = variantData[variantId] || {};
      const date = info.date;
      const inventory = typeof info.inventory === 'number' ? info.inventory : 1;

      // Only preorder when BOTH date is set AND inventory is zero or negative
      const isPreorder = date && String(date).trim() !== '' && inventory <= 0;

      // Update banner
      if (isPreorder) {
        bannerText.textContent = date;
        banner.classList.remove('hidden');
      } else {
        banner.classList.add('hidden');
      }

      // Update ALL submit button text spans (main button + sticky-atc)
      const submitTexts = document.querySelectorAll('[data-addtocart-text]');
      submitTexts.forEach((el) => {
        const current = el.textContent.trim();

        // Don't override Sold out state
        if (current === soldOutLabel) return;

        if (isPreorder) {
          el.textContent = preorderLabel;
        } else if (current === preorderLabel) {
          el.textContent = addToCartLabel;
        }
      });
    }

    // Initial run
    update();

    // Watch the hidden variant id input for changes
    const observer = new MutationObserver(update);
    observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

    // Backup listeners on variant-selects
    hiddenInput.addEventListener('change', update);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(update, 0);
        setTimeout(update, 300);
        setTimeout(update, 700);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();